<template>
  <div>
    <EsHeaderView />
    <div class="container-box">
      <div class="app-container">
        <div class="page-title">{{ $t('message.home.subscribe') }} VIP</div>
        <div class="buy-card" v-if="vipLevel.id">
          <div class="vip-info">
            <div class="vip-name">{{ vipLevel.name }}</div>
            <div class="vip-price-row">
              <span class="price">¥{{ vipLevel.price }}</span>
              <span class="period"> / {{ vipLevel.periodInDays }}{{ $t('message.home.days') }}</span>
            </div>
            <div class="right-list">
              <div class="right-item" v-for="right in (vipLevel.rights || [])" :key="right.id">✓ {{ right.rightName }}</div>
            </div>
          </div>

          <el-divider />

          <div class="pay-method">
            <div class="method-title">{{ $t('message.home.paymentMethod') }}</div>
            <el-radio-group v-model="paymentType">
              <el-radio :label="0">{{ $t('message.home.balancePay') }} ({{ $t('message.home.balance') }}: ¥{{ balance }})</el-radio>
              <el-radio :label="1">{{ $t('message.home.wechatPay') }}</el-radio>
              <el-radio :label="2">{{ $t('message.home.alipay') }}</el-radio>
            </el-radio-group>
          </div>

          <div class="total-row">
            <span>{{ $t('message.home.totalAmount') }}:</span>
            <span class="total-price">¥{{ vipLevel.price }}</span>
          </div>

          <el-button type="primary" class="confirm-btn" :loading="submitting" @click="handleBuy">
            {{ $t('message.home.confirmPay') }}
          </el-button>
        </div>

        <el-empty v-if="!vipLevel.id && !loading" :description="$t('message.home.noData')" />
      </div>
    </div>
    <EsFooterView />
  </div>
</template>

<script>
import { listVipLevel, getMemberCenter, buyPaidMember } from "@/api/upms/member_center";

export default {
  name: "MemberBuy",
  data() {
    return { loading: false, submitting: false, vipLevel: {}, paymentType: 0, balance: '0.00' }
  },
  created() { this.loadData() },
  methods: {
    loadData() {
      this.loading = true
      const vipId = this.$route.query.vipId
      Promise.all([listVipLevel(), getMemberCenter()]).then(([r1, r2]) => {
        const levels = r1.data?.data || []
        this.vipLevel = levels.find(v => v.id === vipId) || levels[0] || {}
        this.balance = r2.data?.data?.balance || '0.00'
        this.loading = false
      }).catch(() => { this.loading = false })
    },
    handleBuy() {
      if (!this.vipLevel.id) return
      this.submitting = true
      buyPaidMember({ vipLevelId: this.vipLevel.id, paymentType: this.paymentType }).then(() => {
        this.submitting = false
        this.$message.success(this.$t('message.home.paySuccess'))
        this.$router.push('/member/center')
      }).catch(() => { this.submitting = false })
    }
  }
}
</script>

<style lang="scss" scoped>
.container-box { background: #f5f5f5; min-height: calc(100vh - 120px); }
.app-container { width: 1200px; margin: 0 auto; padding: 30px 0; }
.page-title { font-size: 22px; font-weight: bold; margin-bottom: 20px; }
.buy-card { background: #fff; border-radius: 8px; padding: 30px; max-width: 600px; }
.vip-name { font-size: 20px; font-weight: bold; margin-bottom: 12px; }
.price { font-size: 28px; color: #e6a23c; font-weight: bold; }
.period { color: #909399; font-size: 14px; }
.right-item { font-size: 14px; color: #606266; margin: 4px 0; }
.pay-method { margin-bottom: 20px; }
.method-title { font-size: 15px; font-weight: bold; margin-bottom: 12px; }
.total-row { display: flex; align-items: center; justify-content: space-between; font-size: 16px; margin-bottom: 20px; }
.total-price { font-size: 24px; font-weight: bold; color: #f56c6c; }
.confirm-btn { width: 100%; font-size: 16px; height: 44px; }
</style>
